export default __webpack_public_path__ + "media/images/home/slide_silver_week_2026_sm-4ef7b843131c4c3c3b7348444d2b0b8b.jpg";